/**
 * Small helpers and the phrases the expansion's orders share (10 §2), so that the same rule is always told
 * in the same words: what "alerted" means on the HUD, where a stated time is shown, how an escort boards.
 */

import type { MissionParams } from '../../../sim/types';

export const fixed = (text: string) => (): string => text;
export const rules = (...lines: string[]) => (_p: MissionParams): string[] => lines;

/** Alert level 2, in the word the HUD's banner uses for it. */
export const ALERTED = 'IF THE GARRISON IS ALERTED - YOUR HUD SHOWS SEARCHING -';
/** Alert level 3. */
export const FULL_ALARM = 'A FULL ALARM - YOUR HUD SHOWS ALARM -';
/** Where every stated time is to be read. */
export const ON_THE_CLOCK = 'THE COUNTDOWN IS ON YOUR HUD FROM THE MOMENT YOU ARE ON THE GROUND.';
export const NO_NOISE_RULE = 'NO NOISE RESTRICTION ON THIS ONE.';
export const QUIET_PISTOL = 'A SUPPRESSED PISTOL, IF THE STOCK HOLDS ONE, BREAKS NO SILENCE. TAKE IT.';
export const NOTHING_SPECIAL = 'NOTHING BEYOND STANDARD ISSUE IS NEEDED FOR THE OBJECTIVE.';

/** Recall as normal, with somebody to put up the ladder first. */
export function escortExtraction(who: string, extra: string): string[] {
  return [`RECALL AS NORMAL: 45 SECONDS OUT, 20 SECONDS ON THE LADDER. ${who} BOARDS BEFORE YOU.`, extra];
}
